// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import dayjs from 'dayjs';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import isLeapYear from 'dayjs/plugin/isLeapYear';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import weekOfYear from 'dayjs/plugin/weekOfYear';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isLeapYear);
dayjs.extend(isoWeeksInYear);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

/**
 * Adds leading zero's before week numbers below 10 (single digit numbers)
 *
 * @param week
 */
export const addLeadingZeroToSingleDigitWeeks = (week: number) => {
	return week < 10 ? '0' + week.toString().slice(-2) : week.toString();
};

/**
 * Return the year and week as a string
 * @param year
 * @param week
 */
export const toYearWeekString = (year: number, week: number): string => {
	return `${year}${addLeadingZeroToSingleDigitWeeks(week)}`;
};

/**
 * Checks if the deadline has passed based on the delivery year, delivery week, and deadline in weeks.
 * A deadline is considered passed if the current week is equal or after the week of the deadline.
 *
 * @param deliveryYear
 * @param deliveryWeek
 * @param deadlineInWeeks
 */
export const hasDeadlinePassed = (deliveryYear: number, deliveryWeek: number, deadlineInWeeks: number) => {
	const currentDate = dayjs();
	const deadline = dayjs().year(deliveryYear).isoWeek(deliveryWeek).subtract(deadlineInWeeks, 'week');

	return currentDate.isoWeekYear() > deadline.isoWeekYear() ||
		(currentDate.isoWeekYear() === deadline.isoWeekYear() && currentDate.isoWeek() >= deadline.isoWeek());
};
